import { ChangeEvent, memo } from 'react';
import { LabelDisplayedRowsArgs, Table, TableBody, TablePagination, TableRow } from '@mui/material';

import { PER_PAGE_OPTIONS, PER_PAGE_OPTIONS_ALL } from 'config';
import { ListParams, Pagination } from '../../types/common';
import { TableHeadCustom } from './index';
import { DataTableFilters, DataTableFilter } from './DataTableFilters';
import { TableHead } from './TableHeadCustom';
import { TableNoData } from './TableNoData';

export interface DataTableProps {
  children: JSX.Element[] | undefined;
  filters?: DataTableFilter;
  tableHead: TableHead;
  pagination?: Pagination | undefined;
  params?: ListParams;
  omitPerPageAll?: boolean;
  onPage?: (id: number) => void;
  onPerPage?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const DataTable = ({
  children,
  filters,
  tableHead,
  pagination,
  params,
  omitPerPageAll,
  onPage,
  onPerPage,
}: DataTableProps) => (
  <>
    {filters && <DataTableFilters filters={filters} />}
    <Table sx={{ width: '100%', height: 'calc(100% - 122px)' }}>
      <TableHeadCustom
        order={params ? (params.order === 'asc' ? 'desc' : 'asc') : undefined}
        orderBy={params ? params.order_by : undefined}
        tableHead={tableHead}
      />
      <TableBody>
        {children && children.length !== 0 ? (
          <>
            {children}
            <TableRow sx={{ height: '100%' }} />
          </>
        ) : (
          <TableNoData />
        )}
      </TableBody>
    </Table>
    {pagination && (
      <TablePagination
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.per_page}
        page={pagination.current_page - 1}
        labelRowsPerPage="Количество строк:"
        labelDisplayedRows={({ from, to, count }: LabelDisplayedRowsArgs) =>
          `${from}–${to} из ${count !== -1 ? count : `более чем ${to}`}`
        }
        sx={{
          borderTop: 'none',
          height: '44px',
          minHeight: '44px',
          marginTop: '-17px',

          '& .MuiTablePagination-toolbar': {
            position: 'absolute',
            right: 0,
            padding: 0,
            margin: 0,
            height: '44px',
            minHeight: '44px',
          },
        }}
        rowsPerPageOptions={
          onPerPage
            ? omitPerPageAll
              ? PER_PAGE_OPTIONS
              : PER_PAGE_OPTIONS_ALL
            : [pagination.per_page]
        }
        onRowsPerPageChange={onPerPage}
        onPageChange={(_: React.MouseEvent<HTMLButtonElement> | null, page: number) =>
          onPage && onPage(page + 1)
        }
      />
    )}
  </>
);

export const DataTableMemo = memo(DataTable);
